// https://bdq-test.xljielong.com/mkt/api/v1/swagger-ui.html#/ app2c
import axios from '@/util/request'
import qs from 'qs'
const prefix = '/mkt/api/v1'

const mkt = {
  
}

export default mkt
